import { NoticeCenterScreenNavigationProps } from "./types"
import React from "react"
import NoticeCenter from "./notice-center"
import { PageRoot } from "~screens/page-root"


const NoticeCenterScreen: React.FC<NoticeCenterScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <NoticeCenter />
    </PageRoot>
  )
}

export default NoticeCenterScreen
